'use client';

import { c as _c } from "react/compiler-runtime";
import { Avatar, Button, Skeleton } from '@common/components';
import { SvgChevronright } from '@common/icon';
import { cn } from '@core/utils';
import { useQuery } from '@tanstack/react-query';
import { AuthQueryOptions } from '@/api';
import { CustomLink } from '@/app/_components/CustomLink';
import { Responsive } from '@/components/organism/Responsive';
import { DONATION_ROUTES } from '@/constants';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { useAuthStore } from '@/stores/AuthStore';
interface ProfileSummarySectionProps {
  className?: string;
}
export const ProfileSummarySection = t0 => {
  const $ = _c(72);
  const {
    className
  } = t0;
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP, true);
  const myInfo = useAuthStore(_temp);
  const isMyInfoLoading = myInfo === undefined;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = AuthQueryOptions["get:/wello/v2/auth/home-donation/my"]();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = !isMyInfoLoading && Boolean(myInfo);
  let t3;
  if ($[1] !== t2) {
    t3 = {
      ...t1,
      select: _temp2,
      enabled: t2
    };
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    data: donationInfo,
    isLoading: isDonationInfoLoading
  } = useQuery(t3);
  const isLoading = isMyInfoLoading || isDonationInfoLoading;
  if (isLoading) {
    let t4;
    if ($[3] !== className) {
      t4 = cn("flex flex-col", className);
      $[3] = className;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <Responsive desktop={<Skeleton className="h-150 w-full rounded-[40px]" />} mobile={<Skeleton className="h-82 w-full rounded-medium" />} />;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    let t6;
    if ($[6] !== t4) {
      t6 = <section className={t4}>{t5}</section>;
      $[6] = t4;
      $[7] = t6;
    } else {
      t6 = $[7];
    }
    return t6;
  }
  if (isDesktopViewport) {
    let t4;
    if ($[8] !== className) {
      t4 = cn("flex flex-col", className);
      $[8] = className;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    const t5 = myInfo?.profileImage;
    let t6;
    if ($[10] !== t5) {
      t6 = <Avatar src={t5} size={48} alt={"\uD504\uB85C\uD544 \uC774\uBBF8\uC9C0"} />;
      $[10] = t5;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    const t7 = myInfo?.nickName;
    let t8;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <span className="font-500">님</span>;
      $[12] = t8;
    } else {
      t8 = $[12];
    }
    let t9;
    if ($[13] !== t7) {
      t9 = <p className="font-700 text-Gray-900 typo-h5">{t7}{t8}</p>;
      $[13] = t7;
      $[14] = t9;
    } else {
      t9 = $[14];
    }
    let t10;
    if ($[15] !== t6 || $[16] !== t9) {
      t10 = <div className="flex items-center gap-16">{t6}{t9}</div>;
      $[15] = t6;
      $[16] = t9;
      $[17] = t10;
    } else {
      t10 = $[17];
    }
    let t11;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <CustomLink href={DONATION_ROUTES.MY_DONATIONS.pathname} className="ml-auto"><Button dimensions="H40" theme="secondary-fill">기부내역 보러가기<SvgChevronright className={cn("size-14 text-Gray-white")} /></Button></CustomLink>;
      $[18] = t11;
    } else {
      t11 = $[18];
    }
    let t12;
    if ($[19] !== t10) {
      t12 = <div className="mb-32 flex items-start justify-between gap-8">{t10}{t11}</div>;
      $[19] = t10;
      $[20] = t12;
    } else {
      t12 = $[20];
    }
    let t13;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <p className="font-500 text-Gray-600 typo-body2">총 기부금액</p>;
      $[21] = t13;
    } else {
      t13 = $[21];
    }
    let t14;
    if ($[22] !== donationInfo?.totalDonationAmount) {
      t14 = donationInfo?.totalDonationAmount?.toLocaleString();
      $[22] = donationInfo?.totalDonationAmount;
      $[23] = t14;
    } else {
      t14 = $[23];
    }
    let t15;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <span className="font-500">원</span>;
      $[24] = t15;
    } else {
      t15 = $[24];
    }
    let t16;
    if ($[25] !== t14) {
      t16 = <div className="flex items-center justify-between">{t13}<p className="font-700 text-Gray-900 typo-h3">{t14}{t15}</p></div>;
      $[25] = t14;
      $[26] = t16;
    } else {
      t16 = $[26];
    }
    let t17;
    if ($[27] !== t12 || $[28] !== t16) {
      t17 = <div className="flex flex-col gap-12 rounded-[40px] bg-B-25 p-40">{t12}{t16}</div>;
      $[27] = t12;
      $[28] = t16;
      $[29] = t17;
    } else {
      t17 = $[29];
    }
    let t18;
    if ($[30] !== t17 || $[31] !== t4) {
      t18 = <section className={t4}>{t17}</section>;
      $[30] = t17;
      $[31] = t4;
      $[32] = t18;
    } else {
      t18 = $[32];
    }
    return t18;
  }
  let t4;
  if ($[33] !== className) {
    t4 = cn("flex flex-col gap-12", className);
    $[33] = className;
    $[34] = t4;
  } else {
    t4 = $[34];
  }
  const t5 = myInfo?.profileImage;
  let t6;
  if ($[35] !== t5) {
    t6 = <Avatar src={t5} size={40} alt={"\uD504\uB85C\uD544 \uC774\uBBF8\uC9C0"} />;
    $[35] = t5;
    $[36] = t6;
  } else {
    t6 = $[36];
  }
  const t7 = myInfo?.nickName ?? "-";
  let t8;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="font-400">님</span>;
    $[37] = t8;
  } else {
    t8 = $[37];
  }
  let t9;
  if ($[38] !== t7) {
    t9 = <p className="font-700 text-Gray-900 typo-body2">{t7}{t8}</p>;
    $[38] = t7;
    $[39] = t9;
  } else {
    t9 = $[39];
  }
  let t10;
  if ($[40] !== t6 || $[41] !== t9) {
    t10 = <div className="flex items-center gap-8">{t6}{t9}</div>;
    $[40] = t6;
    $[41] = t9;
    $[42] = t10;
  } else {
    t10 = $[42];
  }
  let t11;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <p>일반 기부</p>;
    $[43] = t11;
  } else {
    t11 = $[43];
  }
  const t12 = donationInfo?.generalDonationCount || 0;
  let t13;
  if ($[44] !== t12) {
    t13 = <div className="flex items-center justify-between text-Gray-600 typo-caption1">{t11}<p className="font-600">{t12}건</p></div>;
    $[44] = t12;
    $[45] = t13;
  } else {
    t13 = $[45];
  }
  let t14;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <p>지정 기부</p>;
    $[46] = t14;
  } else {
    t14 = $[46];
  }
  const t15 = donationInfo?.specificDonationCount || 0;
  let t16;
  if ($[47] !== t15) {
    t16 = <div className="flex items-center justify-between text-Gray-600 typo-caption1">{t14}<p className="font-600">{t15}건</p></div>;
    $[47] = t15;
    $[48] = t16;
  } else {
    t16 = $[48];
  }
  let t17;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <p>총 기부 건수</p>;
    $[49] = t17;
  } else {
    t17 = $[49];
  }
  const t18 = donationInfo?.donationCount || 0;
  let t19;
  if ($[50] !== t18) {
    t19 = <div className="flex items-center justify-between text-B-500 typo-caption1">{t17}<p className="font-600">{t18}건</p></div>;
    $[50] = t18;
    $[51] = t19;
  } else {
    t19 = $[51];
  }
  let t20;
  if ($[52] !== t13 || $[53] !== t16 || $[54] !== t19) {
    t20 = <div className="mb-12 flex flex-col gap-8">{t13}{t16}{t19}</div>;
    $[52] = t13;
    $[53] = t16;
    $[54] = t19;
    $[55] = t20;
  } else {
    t20 = $[55];
  }
  let t21;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <p className="font-500 text-Gray-600 typo-body4">총 기부금액</p>;
    $[56] = t21;
  } else {
    t21 = $[56];
  }
  let t22;
  if ($[57] !== donationInfo?.totalDonationAmount) {
    t22 = donationInfo?.totalDonationAmount?.toLocaleString();
    $[57] = donationInfo?.totalDonationAmount;
    $[58] = t22;
  } else {
    t22 = $[58];
  }
  let t23;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <span className="font-500 typo-body3">원</span>;
    $[59] = t23;
  } else {
    t23 = $[59];
  }
  let t24;
  if ($[60] !== t22) {
    t24 = <div className="mb-12 flex items-center justify-between">{t21}<p className="font-700 text-Gray-900 typo-body2">{t22}{t23}</p></div>;
    $[60] = t22;
    $[61] = t24;
  } else {
    t24 = $[61];
  }
  let t25;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <CustomLink href={DONATION_ROUTES.MY_DONATIONS.pathname}><Button dimensions="H32" className="w-full" theme="secondary-fill">기부내역 보러가기<SvgChevronright className={cn("size-14 text-Gray-white")} /></Button></CustomLink>;
    $[62] = t25;
  } else {
    t25 = $[62];
  }
  let t26;
  if ($[63] !== t20 || $[64] !== t24) {
    t26 = <div className="rounded-medium bg-B-25 p-20">{t20}{t24}{t25}</div>;
    $[63] = t20;
    $[64] = t24;
    $[65] = t26;
  } else {
    t26 = $[65];
  }
  let t27;
  if ($[66] !== t10 || $[67] !== t26) {
    t27 = <>{t10}{t26}</>;
    $[66] = t10;
    $[67] = t26;
    $[68] = t27;
  } else {
    t27 = $[68];
  }
  let t28;
  if ($[69] !== t27 || $[70] !== t4) {
    t28 = <section className={t4}>{t27}</section>;
    $[69] = t27;
    $[70] = t4;
    $[71] = t28;
  } else {
    t28 = $[71];
  }
  return t28;
};
function _temp(state) {
  return state.myInfo;
}
function _temp2(data) {
  return {
    donationCount: data.context?.donationCount,
    generalDonationCount: data.context?.generalDonationCount,
    homeLoveGovCodeList: data.context?.homeLoveGovCodeList,
    specificDonationCount: data.context?.specificDonationCount,
    totalDonationAmount: data.context?.totalDonationAmount
  };
}